module.exports = __webpack_public_path__ + "static/img/btn-2-active.6104631.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer5/en/btn-2-active.png
// module id = f8N0
// module chunks = 0